import { CATEGORY_UPLOAD_STATUS } from 'Data/constants';
export const getStatusMessage = value => {
	let message = '';
	switch (value) {
		case CATEGORY_UPLOAD_STATUS.UPLOADING:
			message = 'Data uploading is in progress.';
			break;
		case CATEGORY_UPLOAD_STATUS.CATEGORYDATAUPLOADFAILED:
			message = 'Data uploading failed. Please try uploading again.';
			break;
		case CATEGORY_UPLOAD_STATUS.UPLOADED:
			message = 'Data is uploaded.';
			break;
		case CATEGORY_UPLOAD_STATUS.VALIDTING:
			message = 'Data validation is in progress.';
			break;
		case CATEGORY_UPLOAD_STATUS.CATEGORYDATAVALIDATIONFAILED:
			message = 'Data validation failed. Please try uploading again.';
			break;
		case CATEGORY_UPLOAD_STATUS.VALIDATED:
			message = 'Data is validated.';
			break;
		case CATEGORY_UPLOAD_STATUS.DATACOPY:
			message = 'Transfering Data ADLS to SQL';
			break;
		case CATEGORY_UPLOAD_STATUS.DATATRANSFORMATION:
			message = 'Data Transformation in Progress';
			break;
		case CATEGORY_UPLOAD_STATUS.DATATRANSFORMED:
			message = 'Data Transformed Succesfully';
			break;
		case CATEGORY_UPLOAD_STATUS.DATAPUBLISHED:
			message = 'File published successfully.';
			break;
		default:
			message = 'Pipeline Running';
	}
	return message;
};
